export enum NotificationType {
  INFO,
  SUCCESS,
  WARNING,
  ERROR,
}
